import React from 'react';
import { locationInfo, casalePhotos } from '../mock';
import { Car, TrainFront, MapPin, Route } from 'lucide-react';

const icons = [Car, Car, Route, TrainFront];

const Location = () => {
  return (
    <section id="location" className="relative bg-[#3A4A2C] text-[#faf7f2] py-24 md:py-32 overflow-hidden">
      <div
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: `url(${casalePhotos.aerial})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-br from-[#3A4A2C] via-[#3A4A2C]/95 to-[#2b3820]"></div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-2 gap-14 lg:gap-24">
        <div>
          <p className="text-[#e8c98a] text-xs tracking-[0.4em] uppercase mb-5">Come raggiungerci</p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] mb-8">
            Tra Perugia<br />
            <span className="italic">e le colline</span>
          </h2>
          <p className="text-[#faf7f2]/80 text-base md:text-lg leading-relaxed mb-8 max-w-lg">
            {locationInfo.intro}
          </p>

          <div className="flex items-center gap-3 text-[#faf7f2]/90">
            <MapPin size={18} />
            <span className="text-sm tracking-wide">Gaglietole, Umbria · Italia</span>
          </div>

          <a
            href="#contact"
            className="mt-10 inline-flex items-center px-7 py-3.5 text-xs tracking-[0.25em] uppercase bg-[#faf7f2] text-[#3A4A2C] hover:bg-[#C87355] hover:text-white transition-colors duration-300"
          >
            Raggiungici
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {locationInfo.routes.map((r, i) => {
            const Icon = icons[i] || Car;
            return (
              <div
                key={r.title}
                className="border border-[#faf7f2]/15 p-6 hover:border-[#e8c98a]/50 hover:bg-[#faf7f2]/[0.03] transition-colors duration-500 group"
              >
                <div className="w-11 h-11 rounded-full border border-[#faf7f2]/20 flex items-center justify-center mb-5 group-hover:border-[#e8c98a] transition-colors">
                  <Icon size={18} className="text-[#e8c98a]" />
                </div>
                <h4 className="font-serif text-xl mb-2">{r.title}</h4>
                <p className="text-[#faf7f2]/70 text-sm leading-relaxed">{r.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Location;
